import { noop } from 'lodash';

import { FrequentPassageRequest } from '@legacy-types';

import { Form, useForm } from '@shared/forms/components/Form';
import { TextField } from '@shared/forms/components/TextField';
import {
  RedeemFrequentPassageRequestData,
  redeemFrequentPassageRequest,
} from '@shared/frequent-passage-requests/endpoints/redeemFrequentPassageRequest';

type RedeemFrequentPassageRequestButtonFormProps = {
  frequentPassageRequest: FrequentPassageRequest;
  onSave: (data: FrequentPassageRequest) => void;
  onCancel: () => void;
};

export function RedeemFrequentPassageRequestButtonForm({
  frequentPassageRequest,
  onSave,
  onCancel,
}: RedeemFrequentPassageRequestButtonFormProps) {
  const { form, fields } = useForm<RedeemFrequentPassageRequestData>();

  return (
    <Form
      form={form}
      submitLabel="Hand Out"
      confirmation={{
        title: 'Success',
        description: 'Frequent Passage Request handed out.',
      }}
      onSave={onSave}
      onCancel={onCancel}
      action={(data) => redeemFrequentPassageRequest(frequentPassageRequest, data)}
    >
      {frequentPassageRequest.crewMember ? (
        <p>
          You're about to hand out a <strong>{frequentPassageRequest.frequentPassageStickerType.name}</strong> sticker
          to <strong>{frequentPassageRequest.crewMember?.user?.fullName}</strong>.
        </p>
      ) : (
        <p className="text-red-500">This frequent passage request is not assigned to a crew member.</p>
      )}
      <TextField name={fields.code} label="Sticker Code" required />
      <TextField name={fields.internalNote} label="Pick-up Note" />
    </Form>
  );
}
